import { ChecklistCategoryIndicatorInterface } from '../interfaces/checklistCategoryIndicator';
import { ChecklistCategory } from "./checklistCategory";
import { Contract } from "./contract";

export class ChecklistCategoryIndicator implements ChecklistCategoryIndicatorInterface {
    id_checklist_category_indicator?: number;
    fk_id_checklist_category: number;
    checklist_category: ChecklistCategory;
    fk_id_contract: number;
    contract: Contract;
    value: number;

    constructor() {
        this.fk_id_checklist_category = 0;
        this.checklist_category = new ChecklistCategory();
        this.fk_id_contract = 0;
        this.contract = new Contract();
        this.value = 0;
    }
}